import { Route, Routes } from "react-router-dom";

import { PageNotFoundError } from "../components/PageNotFoundError";
import { AccountDeletedPage } from "../pages/auth/AccountDeletedPage";
import { AuthLayout } from "../pages/auth/AuthLayout";
import { CodeInputPage } from "../pages/auth/CodeInputPage";
import { WelcomePage } from "../pages/auth/WelcomePage";

export function AuthRoutes() {
  return (
    <AuthLayout>
      <Routes>
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/check-passcode" element={<CodeInputPage />} />
        <Route path="/account-deleted" element={<AccountDeletedPage />} />
        <Route path="*" element={<PageNotFoundError />} />
      </Routes>
    </AuthLayout>
  );
}
